<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      size="xl"
      :visible="isShowModalTracking"
      title="Tracking"
      cancel-title="Close"
      centered
      ok-title="Accept"
      cancel-variant="outline-secondary"
      hide-footer
      @hide="$emit('update:is-show-modal-tracking', false)"
      @change="(val) => $emit('update:is-show-modal-tracking', val)"
    >
      <user-view-user-timeline-card
        :target="target"
        :actor="actor"
      />
    </b-modal>
  </div>
</template>
<script>
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import {
  BModal, VBModal, BRow, BCol, BPagination,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import DateRangePicker from 'vue2-daterange-picker'
import { ref, watch } from '@vue/composition-api'
import moment from 'moment'
import { formatDate } from '@/utils/utils'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import UserViewUserTimelineCard from '@/components/userManager/detail/UserViewUserTimelineCard.vue'

export default {
  components: {
    UserViewUserTimelineCard,
    BModal,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    isShowModalTracking: {
      type: Boolean,
      required: true,
    },
    target: {
      type: String,
      required: true,
    },
    actor: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const trackings = ref([])
    const toast = useToast()
    const perPage = ref(2)
    const totalTrackings = ref(0)
    const currentPage = ref(1)
    const dateRange = ref({ startDate: null, endDate: null })
    const fetchTrackings = () => {
      store
        .dispatch('app/fetchTrackings', {
          limit: perPage.value,
          page: currentPage.value,
          target: null,
          all_region: false,
          user_id: null,
          create_before: dateRange.value.startDate,
          create_after: dateRange.value.endDate,
          sort: 'DESC',
        })
        .then(response => {
          trackings.value = response.body.data
          totalTrackings.value = response.body.total
        })
        .catch(e => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error fetching trackings',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }
    fetchTrackings()
    watch([perPage, currentPage, dateRange], () => {
      fetchTrackings()
    }, {
      deep: true,
    })
    return {
      trackings,
      perPage,
      totalTrackings,
      currentPage,
      dateRange,
      formatDate,
    }
  },
  methods: {
    formatDateDDMMYYYY(time) {
      return moment(time).format('DD/MM/YYYY')
    },
  },

}
</script>
<style lang="scss">
.rotated {
  transform: rotate(-90deg);
  /* Equal to rotateZ(45deg) */
}
</style>
